// Copyright (c) 2026 FlexiProof. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>

/**
 * @file Type declarations for calculator callbacks.
 * @author James Reid
 */

// @ts-check

// @@imports-types
/* eslint-disable no-unused-vars -- Types only used in comments. */
import { State } from "./State.js"
import { SteppedContainer } from "../components/index.js" 
/* eslint-enable no-unused-vars -- Close disable-enable pair. */

// @@body
/**
 * @callback appStateCb
 * @returns {void}
 */

/**
 * @callback deckRedrawCb
 * @returns {void}
 */

/**
 * @callback deckTweenCb
 * @param {number} tweenProgress
 * @returns {void}
 */

/**
 * @callback steppedContainerCb
 * @param {SteppedContainer} container
 * @returns {void}
 */

/**
 * @callback stepRendererCb
 * @returns {void}
 */

// @@exports
/**
 * @type {appStateCb}
 * @ignore
 */
export let appStateCb

/**
 * @type {deckRedrawCb}
 * @ignore
 */
export let deckRedrawCb

/**
 * @type {deckTweenCb}
 * @ignore
 */
export let deckTweenCb

/**
 * @type {steppedContainerCb}
 * @ignore
 */
export let steppedContainerCb

/**
 * @type {stepRendererCb}
 * @ignore
 */
export let stepRendererCb
